import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { TokenLimitResponse } from '../schema'
import { defaultMaxTokenResponse } from '@/routes/dashboard/files/utils/files-utils'

export type TokenLimit = {
  response: TokenLimitResponse
  loading: boolean
}

export type SelectedFilesState = {
  tokenLimit: TokenLimit
  fileEmbeddingsCache: {
    [filePath: string]: number
  }
}

const initialState: SelectedFilesState = {
  tokenLimit: {
    response: defaultMaxTokenResponse,
    loading: false,
  },
  fileEmbeddingsCache: {},
}

/**
 * Selected Files Slice
 * A slice to hold state for chat files information
 */
export const selectedFilesSlice = createSlice({
  name: 'selectedFilesState',
  initialState,
  reducers: {
    // ============== Listener Middleware Triggers ============== >
    /**
     * Trigger embeddings cache update for a specific file.
     *
     * Causes listener to fetch embeddings metadata from GCS for this file
     * and store it in the cache.
     */
    updateEmbeddingsCache: (_state, _action: PayloadAction<{ filePath: string }>) => {
      // Handled by listener middleware
    },

    // ============== Slice Actions ============== >
    nullifyData: () => initialState,

    // Set Token Limit Loading
    setTokenLimitLoading: (state, action: PayloadAction<boolean>) => {
      state.tokenLimit.loading = action.payload
    },

    // Set Token Limit Response
    setTokenLimitResponse: (state, action: PayloadAction<TokenLimitResponse>) => {
      state.tokenLimit.response = action.payload
    },

    // Set File Embeddings Count (cache)
    setFileEmbeddingsCount: (state, action: PayloadAction<{ filePath: string; count: number }>) => {
      const { filePath, count } = action.payload
      state.fileEmbeddingsCache[filePath] = count
    },

    // Clear File Embeddings Cache (invalidation)
    clearFileEmbeddingsCache: (state, action: PayloadAction<{ filePath: string }>) => {
      const { filePath } = action.payload
      delete state.fileEmbeddingsCache[filePath]
    },
  },
})

// Actions
export const SelectedFilesActions = selectedFilesSlice.actions

export default selectedFilesSlice.reducer
